import { useState } from 'react';
import Button from '@components/common/Button';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@components/common/Dialog';
import { Input } from '@components/common/Input';

interface Props {
  open: boolean;
  mode: 'create' | 'rename';
  initialName?: string;
  initialDescription?: string;
  onClose: () => void;
  onSubmit: (name: string, description?: string) => void;
}

export function DashboardFormModal({
  open, mode, initialName = '', initialDescription = '', onClose, onSubmit,
}: Props) {
  const [name, setName] = useState(initialName);
  const [description, setDescription] = useState(initialDescription);
  if (!open) return null;
  const trimmed = name.trim();
  const submitLabel = mode === 'create' ? 'Create' : 'Save';
  return (
    <Dialog open={open} onOpenChange={(nextOpen) => { if (!nextOpen) onClose(); }}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>
          {mode === 'create' ? 'New dashboard' : 'Rename dashboard'}
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <Input
            aria-label="Name"
            autoFocus
            label="Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          <Input
            aria-label="Description"
            label="Description"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
        </div>
        <div className="mt-5 flex justify-end gap-2">
          <Button variant="secondary" onClick={onClose}>Cancel</Button>
          <Button
            disabled={!trimmed}
            onClick={() => onSubmit(trimmed, description.trim() || undefined)}
          >
            {submitLabel}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
